class CheckoutStatusAdapter {
  closed: boolean;
  id: number;
  pos: boolean;
  description: string;
  terminalUserId: number;
  invoiceBilling: boolean;
  checkout:boolean;

  constructor(
    id: number,
    closed: boolean,
    pos: boolean,
    description: string,
    terminalUserId: number,
    invoiceBilling: boolean,
    checkout:boolean,
  ) {
    this.id = id;
    this.closed = closed;
    this.pos = pos;
    this.description = description;
    this.terminalUserId = terminalUserId;
    this.invoiceBilling = invoiceBilling;
    this.checkout=checkout
  }
}

export default CheckoutStatusAdapter;
